import { render } from "./DocComment.vue?vue&type=template&id=63a5e7bf"
import script from "./DocComment.vue?vue&type=script&lang=js"
export * from "./DocComment.vue?vue&type=script&lang=js"

import "./DocComment.vue?vue&type=style&index=0&id=63a5e7bf&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__